import { FC } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import './index.css';
import { cn } from 'utils/cn';

interface Props {
  selected: Date | null;
  onChange: (value: Date | null) => void;
  title: string;
  titleClassName?: string;
  isPDF?: boolean;
  reactNativeWebView?: boolean;
}

const DatePickerComponent: FC<Props> = ({
  title,
  selected,
  onChange,
  isPDF = false,
  reactNativeWebView = false,
}) => (
  <div className="relative">
    <div
      className={'bg-white top-[-9px] left-[8px] truncate max-w-[85%] absolute text-secondaryText bg-[#fff] rounded left-6 top-1 text-sm z-50'}
    >
      {title}
    </div>
    <div className={cn(
      'rounded-xl border border-[#CBCBCB] w-full p-0',
      { 'p-2.5 ': isPDF && reactNativeWebView },
    )}>
      <DatePicker
        selected={selected}
        onChange={(date) => onChange(date)}
        dateFormat="dd-MM-yyyy"
        wrapperClassName="w-full"
      />
    </div>
  </div>
);

export default DatePickerComponent;
